import {
  AppDispatch,
  GetExcursionsMyMSC,
  GetOnboardServicesByCruiseIdMyMSC,
  myAreaExcursions,
  myAreaOBS,
} from '@msc-b2c/shared-utils';

type RefreshAllInclusiveCatalogParams = {
  dispatch: AppDispatch;
  cruiseId?: string;
  bookingNumber?: string;
  refreshObs: boolean;
  refreshExcursions: boolean;
  includeDepartureAndArrivalPorts?: boolean;
};

/**
 * Refreshes INT130 (OBS) and/or INT133 (excursions) catalog data after an
 * all-inclusive purchase or refund so product availability stays in sync.
 */
export const refreshAllInclusiveCatalog = async ({
  dispatch,
  cruiseId,
  bookingNumber,
  refreshObs,
  refreshExcursions,
  includeDepartureAndArrivalPorts = true,
}: RefreshAllInclusiveCatalogParams): Promise<void> => {
  if (!cruiseId || !bookingNumber) {
    return;
  }

  const refreshTasks: Promise<void>[] = [];

  if (refreshObs) {
    refreshTasks.push(
      new GetOnboardServicesByCruiseIdMyMSC(false, { cruiseID: cruiseId, bookingNumber })
        .getData()
        .then((obsRes) => {
          dispatch(myAreaOBS(obsRes));
        })
        .catch(() => undefined)
    );
  }

  if (refreshExcursions) {
    refreshTasks.push(
      new GetExcursionsMyMSC(false, {
        cruiseId,
        bookingNumber,
        includeDepartureAndArrivalPorts,
      })
        .getData()
        .then((excursionsRes) => {
          dispatch(myAreaExcursions(excursionsRes));
        })
        .catch(() => undefined)
    );
  }

  await Promise.all(refreshTasks);
};
